<template>
  <div ref="iconcontainer" class="icon-container" :class="{'round-corner':icon.round==ICON_LAYOUT_ROUND_RECT,'round':icon.round==ICON_LAYOUT_ROUND}" :style="{'background-color':icon.bgshow?icon.bgcolor:'','color':icon.bgshow||!bfexchange?icon.color:icon.bgcolor}">
    <span class="iconfont" :class="icon.iconclass" :style="{'font-size':fontsize}"></span>
  </div>
</template>

<script>
export default {
  name: 'IconComponent',
  data(){
    return {
      bfexchange:false,
      fontsize:"1em",
      ICON_LAYOUT_RECT:0, // 直角
      ICON_LAYOUT_ROUND_RECT:1, // 圆角矩形
      ICON_LAYOUT_ROUND:2 // 圆形
    }
  },
  props: {
    icon: null
  },
  methods:{
    
  },
  updated(){

     

  },
  mounted(){

      let width = this.$refs.iconcontainer.offsetWidth;

      this.fontsize=(width*0.6)+"px";


  },
  created(){
    
    


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-container{
    display: flex;
    padding: 20%;
}
.round-corner{
    border-radius: 15%;
    overflow: hidden;
}

.round{
    border-radius: 50%;
}
</style>
